export default __webpack_public_path__ + "static/articles-lutein-specialisti-785742b4d5211f3f31b127fd344b541d.jpg";